// extracted by mini-css-extract-plugin
export default {"paginationContainer":"BasePagination_paginationContainer__O-gKr"};